<template>
  <div class="px-2">
    <header>
      <div class="container">
        <div class="row row-wrap align-items-center pt-3">
          <h1 class="col-sm text-center text-sm-left">
            <img src="@/assets/images/logo-heppi.png" srcset="@/assets/images/logo-heppi@2x.png 2x" height="40px">
          </h1>
          <div class="col-sm text-center text-sm-right text-primary">
            <h2>Bem vindo a fatura Heppi!</h2>
          </div>
        </div>
      </div>
    </header>
    <div class="container">
      <p>A fatura Heppi é um jeito fácil e seguro de você pagar o que você precisa para sua formatura. Para acessar uma fatura Heppi, você precisa do link completo. Por exemplo:</p>
      <br>
      <h2 class="text-center text-primary">{{ url }}identificador-da-fatura</h2>
      <br>
      <p>Caso você não tenha acesso ao aplicativo ou não esteja conseguindo acessar no momento, você pode buscar suas faturas em aberto a partir do seu CPF:</p>
      <form id="document_search" class="text-center" style="max-width: 400px; margin: 0 auto;" @submit.prevent>
        <div v-if="error" class="form-group">
          <div class="alert alert-danger">{{ error }}</div>
        </div>
        <div class="form-group">
          <input id="inputDocument" class="form-input" v-model="document" type="tel" v-mask="'###.###.###-##'" placeholder="Digite seu CPF..." :class="{ 'invalid': validation.document }" @blur="bluredField('document')" @focus="resetField('document')">
          <p>{{ validation.document }}</p>
          <br>
        </div>
        <vue-recaptcha class="recaptcha-input" :class="{ 'invalid': validation.recaptcha }" @verify="recaptcha = true; resetField('recaptcha')" @expired="recaptcha = false; bluredField('recaptcha')" sitekey="6LfbnNcUAAAAAMOo1JChhFwEalEELswGiRQMPl4C" :loadRecaptchaScript="true"></vue-recaptcha>
        <p v-if="validation.recaptcha">{{ validation.recaptcha }}</p>
        <div class="text-center form-group">
          <button class="button button-success mx-auto" @click="searchInvoices()">
            Buscar Faturas
          </button>
        </div>
      </form>
      <br>
      <p>Se ainda assim, você não estiver conseguindo acessar sua fatura, entre em contato com o nosso suporte:</p>
      <div class="text-center">
        <template v-for="(contact, index) in contacts">
          <a class="button button-primary ma-1" :key="index" :href="contactLink(contact.type, contact.contact)" target="_blank" rel="nofollow">
            <img v-if="contact.type === 'Whatsapp'" :key="index" src="@/assets/images/whatsapp_negative.png" srcset="@/assets/images/whatsapp_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'Telefone'" :key="index" src="@/assets/images/phone_negative.png" srcset="@/assets/images/phone_negative@2x.png 2x" />
            <img v-else-if="contact.type === 'E-mail'" :key="index" src="@/assets/images/email_negative.png" srcset="@/assets/images/email_negative@2x.png 2x" />
            {{ contactLinkContent(contact.type) }}
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import { mask } from 'vue-the-mask'

export default {
  name: 'home',
  directives: {
    mask
  },
  components: {
    VueRecaptcha
  },
  data () {
    return {
      document: '',
      recaptcha: false,
      blured: {
        document: false,
        recaptcha: false
      },
      serverErros: {
        document: []
      },
      error: null,
      contacts: [
        {
          type: 'Whatsapp',
          contact: '(81) 9 8181.2327'
        },
        {
          type: 'E-mail',
          contact: 'fala@heppi.com.br'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['whatsappLink']),
    url () {
      let url = window.location + ''
      url = url.split('#')[0]
      url = url.split('//')
      return (url[1]) ? url[1] : url[0]
    },
    validation () {
      let validation = { valid: true }

      if (this.blured.document && this.document === '') {
        validation.document = 'Informe o CPF.'
        validation.valid = false
      } else if (this.blured.document && this.document !== '' && !this.documentValidation(this.document)) {
        validation.document = 'Não é um CPF válido.'
        validation.valid = false
      } else if (this.serverErros && this.serverErros.document && this.serverErros.document.length > 0) {
        validation.document = this.serverErros.document[0]
        validation.valid = false
      }

      if (this.blured.recaptcha && !this.recaptcha) {
        validation.recaptcha = 'Use o recaptcha.'
        validation.valid = false
      }

      return validation
    },
    expirationData () {
      return btoa(JSON.stringify({
        document: this.document.replace(/[-.]/g, ''),
        expires: this.$moment().add(30, 'minutes').format('YYYY-MM-DD HH:mm:ss')
      }))
    }
  },
  methods: {
    numberPhone (phone) {
      return phone.replace(/[)(-. ]/g, '')
    },
    resetField (field) {
      if (this.serverErros && this.serverErros[field] && this.serverErros[field].length > 0) {
        this.serverErros[field] = []
      }
      this.error = null
    },
    bluredField (field) {
      this.blured[field] = true
    },
    documentValidation (cpf) {
      let numCpf = cpf.replace(/[.-]/g, '')
      if (numCpf.length !== 11) {
        return false
      } else {
        if (numCpf[0] === numCpf[1] && numCpf[1] === numCpf[2] && numCpf[2] === numCpf[3] && numCpf[3] === numCpf[4] && numCpf[4] === numCpf[5] && numCpf[5] === numCpf[6] && numCpf[6] === numCpf[7] && numCpf[7] === numCpf[8] && numCpf[8] === numCpf[9] && numCpf[9] === numCpf[10]) {
          return false
        } else {
          let soma1 = numCpf[0] * 10 + numCpf[1] * 9 + numCpf[2] * 8 + numCpf[3] * 7 + numCpf[4] * 6 + numCpf[5] * 5 + numCpf[6] * 4 + numCpf[7] * 3 + numCpf[8] * 2
          let soma2 = numCpf[0] * 11 + numCpf[1] * 10 + numCpf[2] * 9 + numCpf[3] * 8 + numCpf[4] * 7 + numCpf[5] * 6 + numCpf[6] * 5 + numCpf[7] * 4 + numCpf[8] * 3 + numCpf[9] * 2

          let resultado1 = (soma1 * 10 % 11 > 9) ? 0 : soma1 * 10 % 11
          let resultado2 = (soma2 * 10 % 11 > 9) ? 0 : soma2 * 10 % 11

          if (resultado1 === parseInt(numCpf[9]) && resultado2 === parseInt(numCpf[10])) {
            return true
          } else {
            return false
          }
        }
      }
    },
    contactLink (type, title) {
      switch (type) {
        case 'E-mail':
          return 'mailto:' + title
        case 'Whatsapp':
          return this.whatsappLink
      }
    },
    contactLinkContent (type) {
      switch (type) {
        case 'E-mail':
          return 'Envia um e-mail'
        case 'Whatsapp':
          return 'Fala no Whatsapp'
      }
    },
    searchInvoices () {
      this.bluredField('document')
      this.bluredField('recaptcha')

      if (this.validation.valid) {
        localStorage.setItem('at3', this.expirationData)
        this.$router.push({ name: 'myInvoices' })
      } else {
        this.error = 'Verifique os campos em vermelho'
      }
    }
  },
  mounted () {
    localStorage.deleteItem('at3')
  }
}
</script>
